export default [
  {
    path: '/service-system',
    name: 'service-system',
    component: () => import('@/views/service/v2/Chat.vue'),
    meta: {
      resource: 'view-service',
      action: 'read',
      title: 'breadcrumb.chat',
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
    },
  },
]
